import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { ProductResponse } from 'src/app/models/product.model';
import { ProcessRequest, ProductionProcess, ProductionProcessProduct, ProductionProcessResponse } from 'src/app/models/production-process';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { ProductService } from 'src/app/services/product.service';
import { ProductionProcessService } from 'src/app/services/production-process.service';
import { WarehouseService } from 'src/app/services/warehouse.service';

export interface WarehouseProcessDetail {
  warehouseId: number;
  data: any;
  quantity: number;
  existences: number;
  principal: boolean;
}

export interface ProductProcessDetail {
  productionProcessProduct: ProductionProcessProduct;
  warehouseDetails: WarehouseProcessDetail[];
  total: number;
}

export interface ProductProcessDetailTemp {
  product: ProductResponse;
  warehouseDetails: WarehouseProcessDetail[];
  total: number;
}

@Component({
  selector: 'app-execution-production-process',
  templateUrl: './execution-production-process.component.html',
  styleUrls: ['./execution-production-process.component.scss']
})
export class ExecutionProductionProcessComponent implements OnInit {
  currentProcess: ProductionProcess = null;
  currentWarehouse: WarehouseResponse = null;
  process: ProductionProcess[] = [];
  processFilter: ProductionProcess[] = [];

  productProcesses: ProductionProcessProduct[] = [];
  processDetails: ProductProcessDetail[] = [];
  processDetailsIn: ProductProcessDetail[] = [];
  processDetailsInTemp: ProductProcessDetailTemp[] = [];
  processDetailsOut: ProductProcessDetail[] = [];

  warehouses: WarehouseResponse[] = [];
  filterWarehouses: WarehouseResponse[] = [];
  inputs = {
    processes: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: null as any
    },
    warehouse: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    }
  };
  loading = false;
  buttonExecute: ButtonLoading = new ButtonLoading('btn-success', false, ' PROCESAR', 'fa-random');
  timeout = null;

  constructor(
    private warehouseService: WarehouseService,
    private inventoryService: InventoryService,
    private productService: ProductService,
    private productionProcessService: ProductionProcessService,
    private toastService: ToastrService) { }

  ngOnInit(): void {
    this.getProductionProcesses();
    this.getWarehouses("");
  }

  getProductionProcesses() {
    this.productionProcessService.getAllProductionProcess().subscribe({
      next: (response: ResponseObject) => {
        this.process = response.data;
        this.processFilter = this.process;
      },
      error: (err: HttpErrorResponse) => {
        this.toastService.error("Error al obtener los procesos productivos", "Error");
      }
    });
  }

  getWarehouses(clue) {
    this.warehouseService.getWarehouseByClue(clue).subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.filterWarehouses = this.warehouses;
        if (this.filterWarehouses.length == 0) {
          this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
        } else if (this.filterWarehouses.length == 1) {
          this.changeInput(this.inputs.warehouse, this.filterWarehouses[0].name, true, null, 'fa-circle-check', this.filterWarehouses[0]);
        } else {
          if (clue == "") {
            this.changeInput(this.inputs.warehouse, clue, false, null, 'fa-asterisk', null);
          } else {
            this.changeInput(this.inputs.warehouse, clue, false, null, 'fa-list', null);
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
      }
    });
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  writeProcess(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.processes.class = "typing";
    this.timeout = setTimeout(() => {
      this.processFilter = this.process.filter((p) => {
        return p.name.toLowerCase().includes(inputValue.toLowerCase());
      });
      if (this.processFilter.length == 0) {
        this.changeInput(this.inputs.processes, null, false, null, 'fa-xmark', null);
      } else if (this.processFilter.length == 1) {
        this.checkProcess(this.processFilter[0]);
      } else {
        this.changeInput(this.inputs.processes, inputValue, false, null, 'fa-list', null);
      }
    }, 500);
  }

  checkProcess(processItem: ProductionProcess) {
    this.inputs.processes.class = "fa-circle-check";
    this.inputs.processes.verified = true;
    this.inputs.processes.data = processItem;
    this.inputs.processes.value = processItem.name;
    this.setProcess();
  }

  writeWarehouse(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.warehouse.class = "typing";
    this.timeout = setTimeout(() => {
      this.getWarehouses(inputValue);
    }, 500);
  }

  checkWarehouse(warehouse: WarehouseResponse) {
    this.inputs.warehouse.class = "fa-circle-check";
    this.inputs.warehouse.verified = true;
    this.inputs.warehouse.data = warehouse;
    this.inputs.warehouse.value = warehouse.name;
    this.currentWarehouse = warehouse;
  }

  setProcess() {
    this.currentProcess = this.inputs.processes.data;
    this.getProductionProcessesDetails();
  }

  getProductionProcessesDetails() {
    if (this.currentProcess == null) {
      this.toastService.warning("Seleccione un proceso productivo", "Advertencia");
      return;
    }

    this.productionProcessService.getProductionProcessDetails(this.currentProcess.id).subscribe({
      next: (response: ResponseObject) => {
        this.productProcesses = response.data;
        this.generateProcess();
      },
      error: (err: HttpErrorResponse) => {
        this.toastService.error("Error al obtener los detalles de los procesos productivos", "Error");
      }
    });
  }

  generateProcess() {
    if (this.currentProcess == null) {
      this.toastService.warning("Seleccione un proceso productivo", "Advertencia");
      return;
    }

    this.processDetails = [];
    this.processDetailsIn = [];
    this.processDetailsOut = [];
    this.processDetailsInTemp = [];

    this.productProcesses.forEach(pp => {
      const detail: ProductProcessDetail = {
        productionProcessProduct: pp,
        warehouseDetails: [
          {
            warehouseId: null,
            data: null,
            quantity: 0,
            existences: 0,
            principal: true
          },
        ],
        total: 0
      };
      this.processDetails.push(detail);
      if (pp.type == "INPUT") {
        this.processDetailsIn.push(detail);
      } else {
        this.processDetailsOut.push(detail);
      }
    });
  }

  getDisabledSave() {
    if (this.currentProcess == null && !this.inputs.warehouse.verified) {
      return true;
    }

    for (let detail of this.processDetailsIn) {
      for (let warehouseDetail of detail.warehouseDetails) {
        // if (warehouseDetail.warehouseId == null || warehouseDetail.quantity <= 0) {
        if (warehouseDetail.warehouseId == null) {
          return true;
        }
      }
    }

    for (let detail of this.processDetailsOut) {
      for (let warehouseDetail of detail.warehouseDetails) {
        // if (warehouseDetail.warehouseId == null || warehouseDetail.quantity <= 0) {
        if (warehouseDetail.warehouseId == null) {
          return true;
        }
      }
    }

    return false;
  }

  executeProcess() {

    if (!this.inputs.processes.verified) {
      this.toastService.warning("Seleccione un proceso productivo", "Advertencia");
      return;
    }

    if (!this.inputs.warehouse.verified) {
      this.toastService.warning("Seleccione una bodega de salida", "Advertencia");
      return;
    }

    const warehousePrincipalId = this.inputs.warehouse.data.id;
    let productWarehouseInputs = [];
    let productWarehouseOutputs = [];
    let productTempWarehouseInputs = [];

    for (let i = 0; i < this.processDetailsIn.length; i++) {
      const element = this.processDetailsIn[i];
      let total = 0;
      for (let j = 0; j < element.warehouseDetails.length; j++) {
        const elementDetail = element.warehouseDetails[j];
        if (elementDetail.warehouseId==null) {
          this.toastService.warning("Debes seleccionar todas las bodegas que necesites");
          return;
        }

        if (elementDetail.warehouseId!=warehousePrincipalId) {
          productWarehouseInputs.push({
            productId: element.productionProcessProduct.productId,
            warehouseOutputId: elementDetail.warehouseId,
            quantity: elementDetail.quantity
          });
        }
        total += elementDetail.quantity

      }

      if (total < element.productionProcessProduct.quantity) {
        this.toastService.warning("Las cantidades de cada proceso deben ser completadas");
        return;
      }

      if (total > element.productionProcessProduct.quantity) {
        this.toastService.warning("Las cantidades de uno o mas procesos supera lo requerido");
        return;
      }
    }

    for (let i = 0; i < this.processDetailsInTemp.length; i++) {
      const element = this.processDetailsInTemp[i];

      if (element.product == null) {
        this.toastService.warning("Debes seleccionar todos los productos que necesites");
        return;
      }

      for (let j = 0; j < element.warehouseDetails.length; j++) {
        const elementDetail = element.warehouseDetails[j];
        if (elementDetail.warehouseId==null) {
          this.toastService.warning("Debes seleccionar todas las bodegas que necesites");
          return;
        }

        if (elementDetail.warehouseId!=warehousePrincipalId) {
          productTempWarehouseInputs.push({
            productId: element.product.id,
            warehouseOutputId: elementDetail.warehouseId,
            quantity: elementDetail.quantity
          });
        }

      }

    }

    for (let i = 0; i < this.processDetailsOut.length; i++) {
      const element = this.processDetailsOut[i];
      for (let j = 0; j < element.warehouseDetails.length; j++) {
        const elementDetail = element.warehouseDetails[j];
        productWarehouseOutputs.push({
          productId: element.productionProcessProduct.productId,
          warehouseOutputId: elementDetail.warehouseId,
        });
      }
    }


    const request = {
      warehouseOutput: this.inputs.warehouse.data.id,
      productWarehouseInputs: productWarehouseInputs,
      productWarehouseOutputs: productWarehouseOutputs,
      productTempWarehouseInputs: productTempWarehouseInputs
    };

    this.buttonExecute.loading = true;
    this.buttonExecute.message = " Procesando...";

    this.productionProcessService.executeProductionProcess(this.currentProcess.id, request).subscribe({
      next: (response: ResponseObject) => {
        this.buttonExecute.loading = false;
        this.buttonExecute.message = " PROCESAR";
        this.toastService.success("Proceso productivo ejecutado con éxito", "Éxito");
        this.currentProcess = null;
        this.resetData();
      },
      error: (err: HttpErrorResponse) => {
        this.buttonExecute.loading = false;
        this.buttonExecute.message = " PROCESAR";
        this.toastService.error("Error al ejecutar el proceso productivo, revise existencias", "Error");
      }
    });
  }

  resetData(){
    this.changeInput(this.inputs.warehouse, null, false, null, 'fa-list', null);
    this.changeInput(this.inputs.processes, null, false, null, 'fa-list', null);
  }

  addDetailWarehouse(detail: ProductProcessDetail) {
    detail.warehouseDetails.push({
      warehouseId: null,
      data: null,
      quantity: 0,
      existences: 0,
      principal: false
    });
  }

  addDetailWarehouseTemp(detail: ProductProcessDetailTemp) {
    detail.warehouseDetails.push({
      warehouseId: null,
      data: null,
      quantity: 0,
      existences: 0,
      principal: false
    });
  }

  removeDetailWarehouse(detail: ProductProcessDetail, index: number) {
    if (detail.warehouseDetails.length <= 1) {
      return;
    }
    detail.warehouseDetails.splice(index, 1);
  }

  getTotalProduct(productDetail: ProductProcessDetail){
    let total = 0;
    for (let i = 0; i < productDetail.warehouseDetails.length; i++) {
      const element = productDetail.warehouseDetails[i];
      total += element.quantity;
    }
    productDetail.total = total;
    return total;
  }

  addProductTemp(){
    this.processDetailsInTemp.push({
      product: null,
      warehouseDetails: [
        {
          warehouseId: null,
          data: null,
          quantity: 0,
          existences: 0,
          principal: true
        }
      ],
      total: 0
    });
  }
  removeProductTemp(index: number){
    this.processDetailsInTemp.splice(index,1);
  }
}
